<script setup lang="ts">
import { onClickOutside } from '@vueuse/core'

import MenuIcon from '~/components/atoms/icons/MenuIcon.vue'
import OperatorIcon from '~/components/organisms/Header/OperatorIcon.vue'
import type { Operator } from '~/entities/operator'

const props = defineProps<{
  isActive: boolean
  currentOperator: Operator | null
}>()

const emit = defineEmits<{
  (e: 'update:isActive', v: boolean): void
}>()

const parent = ref<HTMLElement | null>(null)

const close = () => {
  emit('update:isActive', false)
}

const toggle = () => {
  emit('update:isActive', !props.isActive)
}

onClickOutside(parent, () => {
  close()
})
</script>

<template>
  <div ref="parent" class="the-main-menu">
    <div class="icon-wrapper">
      <button class="more" @click="toggle">
        <OperatorIcon v-if="currentOperator" :operator="currentOperator" />
        <MenuIcon v-else :size="24" />
      </button>
    </div>

    <Transition>
      <div v-show="isActive" class="content">
        <slot></slot>
      </div>
    </Transition>
  </div>
</template>

<style scoped lang="scss">
.the-main-menu {
  position: relative;
}

.icon-wrapper {
  display: flex;
  align-items: center;
}

.more {
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  -webkit-tap-highlight-color: transparent;
}

.content {
  position: absolute;
  top: auto;
  right: 8px;
  margin-top: 12px;
  background: var(--semantic-tokens-neutral-default-background);
  border: 1px solid var(--semantic-tokens-neutral-default-border);
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 100;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
